import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PublicSiteConfigBaseComponent } from 'src/app/base/publicSiteConfigBase.component';
import { ViewType } from 'src/app/enums/viewType.enum';
import { HelperService } from 'src/services/helperService';
import { HistoryService } from 'src/services/historyService';
import { PublicSiteConfig } from 'src/services/publicSiteConfig.service';

@Component({
    selector: 'app-i-banner-success-booking',
    templateUrl: './i-banner-success-booking.component.html',
    styleUrls: ['./i-banner-success-booking.component.sass'],
    standalone: false
})

export class IBannerSuccessBookingComponent extends PublicSiteConfigBaseComponent implements OnInit {
  toHome: string=""
  LanguageForCountry:string = ""
  
  public recievedDataScheduler:any = history.state.AppointmentInfo as {}
  imagen_banner :string = ''
  endPointSplit:any
  
  constructor(
    public helperService: HelperService, 
    public navigation: HistoryService,
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    public override publicSiteConfig:PublicSiteConfig)
  { 
    super(publicSiteConfig, ViewType.Incadea);
    if(!this.recievedDataScheduler){
      this.route.params.subscribe(params => {
        this.indexbrand = params['brand'];
        this.indexCountry = params['country'];
      });
      const bannermanagementURL = `WebView/i-bannerManage/${this.indexbrand}/${this.indexCountry}`
      this.router.navigate([bannermanagementURL]);  
    }
    this.LanguageForCountry = this.router.getCurrentNavigation()?.previousNavigation?.extras.state?.['LanguageForCountry']
    this.toHome= this.navigation.getHistory()
  }
  
  protected override afterConfigLoaded(): void {
    if(this.recievedDataScheduler){
      this.pushToDataLayer()
     }
    this.route.params.subscribe(params => {
      this.indexbrand = params['brand'];
      this.indexCountry = params['country'];
    })
    this.reloadCurrentBrand();
  }

  async reloadCurrentBrand() {
    await this.loadConfig();
    this.imagen_banner = this.CurrentBrand.imagen_banner;
  }
  
  pushToDataLayer() {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push( this.recievedDataScheduler);
  }
  
}

